"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRegexp = void 0;
const REGEXP_MATCH_REGEXP = /^(?:\/(.*)\/([a-z]*)|(.*))$/;
/**
 * Парсит строку как регулярку
 * Например, принимает строку `/regexp-content/gi` и возвращает объект с регуляркой, флаги, и паттерн
 * Может так же принимать любую строку и превращать её в регулярку
 */
const parseRegexp = (string, options = {}) => {
    var _a, _b;
    if (typeof string !== 'string') {
        throw new Error('ParseRegexp only accepts string as an argument!');
    }
    const allowedFlags = (_a = options.allowedFlags) !== null && _a !== void 0 ? _a : ['g', 'i'];
    const m = string.match(REGEXP_MATCH_REGEXP);
    if (!m) {
        throw new Error('Invalid regexp string!');
    }
    const pattern = m[1] || m[3];
    const flags = ('' + (m[2] || '') + ((_b = options.flags) !== null && _b !== void 0 ? _b : ''))
        .split('')
        .filter((flag, i, ar) => ar.indexOf(flag) === i && ~allowedFlags.indexOf(flag))
        .join('');
    return {
        regex: new RegExp(pattern, flags),
        pattern,
        flags
    };
};
exports.parseRegexp = parseRegexp;
//# sourceMappingURL=parse-regexp.util.js.map